import React, { useEffect, useState } from "react";

const PostList = ({ fetchPostsFn, sectionTitle }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetchPostsFn();
            if (res.success) {
                setPosts(res.data);
            } else {
                setMessage(res.message);
            }
            setLoading(false);
        };
        fetchData();
    }, [fetchPostsFn]);

    if (loading) {
        return <div className="text-center mt-8">Loading posts...</div>;
    }

    if (message) {
        return <div className="text-red-500 text-center mt-8">{message}</div>;
    }

    // Function to extract YouTube video ID
    const getYoutubeID = (url) => {
        const match = url?.match(/(?:v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : null;
    };

    return (
        <div className="max-w-4xl mx-auto mt-10 p-6 bg-white dark:bg-gray-900 rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-white">{sectionTitle}</h2>

            {posts.map((post) => (
                <div key={post.id} className="border-b border-gray-300 dark:border-gray-700 py-6">
                    <h3 className="text-xl font-semibold text-blue-600 dark:text-blue-300">{post.title}</h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{new Date(post.event_date).toLocaleDateString()}</p>
                    <p className="mt-2 text-gray-700 dark:text-gray-300">{post.description}</p>

                    {post.video_url && (
                        <div className="mt-4">
                            {/* YouTube embed if valid */}
                            {getYoutubeID(post.video_url) ? (
                                <iframe
                                    className="w-full h-64 rounded-lg"
                                    src={`https://www.youtube.com/embed/${getYoutubeID(post.video_url)}`}
                                    title="YouTube video"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            ) : (
                                <a href={post.video_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                                    Watch Video
                                </a>
                            )}
                        </div>
                    )}

                    <span className="inline-block mt-4 text-xs bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 px-2 py-1 rounded">
                        {post.type.toUpperCase()}
                    </span>
                </div>
            ))}

            {posts.length === 0 && (
                <div className="text-center text-gray-500 dark:text-gray-400 mt-4">No posts available</div>
            )}
        </div>
    );
};

export default PostList;
